export default __webpack_public_path__ + "static/media/CALENDÁRIO ACADÉMICO ACTUALIZADO-29.02.24.6fb0cb45.pdf";